import axios from "../api/axios";
import useAuth from "./UseAuth";
const LOGIN_URL = '/auth';

const useLogout = () => {
    const { setAuth } = useAuth();

    const logout = async () => {
        setAuth({});
        try {
            const response = await axios(LOGIN_URL+'/logout', {
                withCredentials: true
            });
        } catch (err) {
            console.error(err);
        }
    }

    return logout;
}

export default useLogout